import { render } from "./flowForm.vue?vue&type=template&id=662369b7&scoped=true"
import script from "./flowForm.vue?vue&type=script&lang=js"
export * from "./flowForm.vue?vue&type=script&lang=js"

import "./flowForm.vue?vue&type=style&index=0&id=662369b7&scoped=true&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-662369b7"]])

export default __exports__